import registryJson from "../../../data/themes/candidate-theme-registry.v1.json";
import type { DealCatalog } from "../../deal-protocol/src";
import type { CandidateThemeDefinition } from "./candidate-theme-types";

interface RegistryEntry {
  readonly key: string;
  readonly catalogRevision: string;
  readonly theme: CandidateThemeDefinition;
}

const entries = registryJson.themes as unknown as readonly RegistryEntry[];

export const CANDIDATE_THEME_KEYS: readonly string[] = entries.map(
  (entry) => entry.key
);
export type CandidateThemeKey = string;

export interface CandidateThemeBundle {
  readonly key: CandidateThemeKey;
  readonly catalogRevision: string;
  readonly catalog: DealCatalog;
  readonly theme: CandidateThemeDefinition;
}

const BUNDLES = new Map<CandidateThemeKey, CandidateThemeBundle>(
  entries.map((entry) => [
    entry.key,
    {
      key: entry.key,
      catalogRevision: entry.catalogRevision,
      catalog: {
        catalogRevision: entry.catalogRevision,
        themes: [entry.theme]
      },
      theme: entry.theme
    }
  ])
);

export function candidateThemeBundle(key: CandidateThemeKey): CandidateThemeBundle {
  const bundle = BUNDLES.get(key);
  if (bundle === undefined) throw new Error(`Unknown candidate theme: ${key}`);
  return bundle;
}
